export const styles = {
  container: {
    maxWidth: "1024px",
    margin: "0 auto",
    padding: "1.5rem",
    background: "linear-gradient(to bottom right, #e0e7ff, #f3e8ff)",
    minHeight: "100vh",
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  characterSelector: {
    backgroundColor: "#fff",
    borderRadius: "0.5rem",
    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
    marginBottom: "1.5rem",
    padding: "1.5rem",
    border: "2px solid #c7d2fe",
  },
  selectorTitle: {
    fontSize: "1.25rem",
    fontWeight: "bold",
    color: "#1f2937",
    marginBottom: "1rem",
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
  },
  selectContainer: {
    position: "relative",
    width: "100%",
  },
  select: {
    width: "100%",
    padding: "0.75rem",
    fontSize: "1rem",
    border: "2px solid #d1d5db",
    borderRadius: "0.5rem",
    backgroundColor: "#fff",
    cursor: "pointer",
    appearance: "none",
    background: `url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e") no-repeat right 0.75rem center/16px 16px`,
  },
  loadingContainer: {
    textAlign: "center",
    padding: "2rem",
    backgroundColor: "#f9fafb",
    borderRadius: "0.5rem",
    border: "2px solid #e5e7eb",
  },
  errorContainer: {
    textAlign: "center",
    padding: "2rem",
    backgroundColor: "#fef2f2",
    borderRadius: "0.5rem",
    border: "2px solid #fecaca",
    color: "#dc2626",
  },
  headerCard: {
    backgroundColor: "#fff",
    borderRadius: "0.5rem",
    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
    marginBottom: "1.5rem",
    padding: "1.5rem",
    border: "2px solid #c7d2fe",
  },
  headerFlex: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    marginBottom: "1rem",
  },
  avatar: {
    width: "4rem",
    height: "4rem",
    backgroundColor: "#e0e7ff",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  characterName: {
    fontSize: "1.875rem",
    fontWeight: "bold",
    color: "#1f2937",
    marginBottom: "0.5rem",
  },
  infoGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "1rem",
    fontSize: "0.875rem",
  },
  infoItem: {
    color: "#374151",
  },
  label: {
    fontWeight: "600",
  },
  combatStats: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "1rem",
    marginTop: "1rem",
  },
  statCard: {
    textAlign: "center",
    padding: "0.75rem",
    borderRadius: "0.5rem",
    border: "1px solid",
  },
  statCardRed: {
    backgroundColor: "#fef2f2",
    borderColor: "#fecaca",
  },
  statCardBlue: {
    backgroundColor: "#eff6ff",
    borderColor: "#bfdbfe",
  },
  statCardBrown: {
    backgroundColor: "#f0fdf4",
    borderColor: "#755224",
  },
  statValue: {
    fontSize: "1.25rem",
    fontWeight: "bold",
    marginBottom: "0.25rem",
  },
  statValueRed: {
    color: "#b91c1c",
  },
  statValueBlue: {
    color: "#1d4ed8",
  },
  statValueBrown: {
    color: "#166534",
  },
  statLabel: {
    fontSize: "0.875rem",
  },
  statLabelRed: {
    color: "#dc2626",
  },
  statLabelBlue: {
    color: "#2563eb",
  },
  statLabelBrown: {
    color: "#16a34a",
  },
  abilityCard: {
    backgroundColor: "#fff",
    borderRadius: "0.5rem",
    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
    padding: "1.5rem",
    border: "2px solid #d8b4fe",
    marginBottom: "1.5rem",
  },
  abilityTitle: {
    fontSize: "1.25rem",
    fontWeight: "bold",
    color: "#1f2937",
    marginBottom: "1rem",
  },
  abilityGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(130px, 1fr))",
    gap: "1rem",
  },
  abilityItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0.75rem",
    backgroundColor: "#f9fafb",
    borderRadius: "0.5rem",
    textAlign: "center",
  },
  abilityName: {
    fontWeight: "500",
    marginBottom: "0.5rem",
  },
  abilityModifier: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    color: "#1f2937",
  },
  abilityScore: {
    fontSize: "0.875rem",
    color: "#6b7280",
    marginTop: "0.25rem",
  },
  skillsCard: {
    backgroundColor: "#fff",
    borderRadius: "0.5rem",
    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
    padding: "1.5rem",
    border: "2px solid #e5e7eb",
    marginBottom: "1.5rem",
  },
  skillsTitle: {
    fontSize: "1.25rem",
    fontWeight: "bold",
    color: "#1f2937",
    marginBottom: "1rem",
    textAlign: "center",
    letterSpacing: "0.1em",
  },
  skillsTable: {
    width: "100%",
    borderCollapse: "collapse",
  },
  skillsHeaderRow: {
    backgroundColor: "#f9fafb",
    borderBottom: "2px solid #d1d5db",
  },
  skillsHeaderCell: {
    padding: "0.75rem 0.5rem",
    fontSize: "0.75rem",
    fontWeight: "bold",
    color: "#374151",
    textAlign: "center",
    borderRight: "1px solid #d1d5db",
    letterSpacing: "0.05em",
    cursor: "pointer",
    transition: "background-color 0.2s",
    userSelect: "none",
  },
  skillsHeaderCellLast: {
    padding: "0.75rem 0.5rem",
    fontSize: "0.75rem",
    fontWeight: "bold",
    color: "#374151",
    textAlign: "center",
    letterSpacing: "0.05em",
    cursor: "pointer",
    transition: "background-color 0.2s",
    userSelect: "none",
  },
  skillsHeaderCellHover: {
    backgroundColor: "#e5e7eb",
  },
  skillsHeaderCellActive: {
    backgroundColor: "#ddd6fe",
    color: "#5b21b6",
  },
  sortableHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.25rem",
  },
  skillRow: {
    borderBottom: "1px solid #e5e7eb",
    transition: "background-color 0.2s",
  },
  skillRowHover: {
    backgroundColor: "#f9fafb",
  },
  skillCell: {
    padding: "0.5rem",
    textAlign: "center",
    borderRight: "1px solid #e5e7eb",
    verticalAlign: "middle",
  },
  skillCellLast: {
    padding: "0.5rem",
    textAlign: "center",
    verticalAlign: "middle",
  },
  proficiencyCircle: {
    width: "16px",
    height: "16px",
    borderRadius: "50%",
    border: "2px solid #6b7280",
    backgroundColor: "transparent",
    cursor: "pointer",
    transition: "all 0.2s",
    display: "inline-block",
  },
  proficiencyCircleFilled: {
    backgroundColor: "#1f2937",
    borderColor: "#1f2937",
  },
  abilityMod: {
    fontSize: "0.75rem",
    fontWeight: "bold",
    color: "#6b7280",
    letterSpacing: "0.05em",
  },
  skillNameButton: {
    background: "none",
    border: "none",
    fontSize: "0.875rem",
    fontWeight: "500",
    color: "#374151",
    cursor: "pointer",
    padding: "0.25rem 0.5rem",
    borderRadius: "0.25rem",
    transition: "all 0.2s",
    textAlign: "left",
    width: "100%",
  },
  skillNameButtonProficient: {
    color: "#1d4ed8",
    fontWeight: "600",
  },
  skillNameButtonHover: {
    backgroundColor: "#e5e7eb",
  },
  bonusValue: {
    fontSize: "0.875rem",
    fontWeight: "bold",
    color: "#1f2937",
    backgroundColor: "#f9fafb",
    border: "1px solid #d1d5db",
    borderRadius: "0.25rem",
    padding: "0.25rem 0.5rem",
    minWidth: "35px",
    display: "inline-block",
  },
  instructionsCard: {
    marginTop: "1.5rem",
    backgroundColor: "#fff",
    borderRadius: "0.5rem",
    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
    padding: "1rem",
    border: "2px solid #e5e7eb",
  },
  instructionsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "1rem",
    fontSize: "0.875rem",
    color: "#6b7280",
  },
  instructionItem: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
  },
  warning: {
    marginTop: "0.5rem",
    fontSize: "0.75rem",
    color: "#ee7230",
  },
};

export const createThemedStyles = (theme) => ({
  container: {
    maxWidth: "1024px",
    margin: "0 auto",
    padding: "1.5rem",
    background:
      theme.gradient ||
      `linear-gradient(to bottom right, ${theme.background}, ${theme.surface})`,
    minHeight: "100vh",
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    transition: "background 0.3s ease",
  },
  characterSelector: {
    backgroundColor: theme.surface,
    borderRadius: "0.5rem",
    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
    marginBottom: "1.5rem",
    padding: "1.5rem",
    border: `2px solid ${theme.primary}30`,
  },
  selectorTitle: {
    fontSize: "1.25rem",
    fontWeight: "bold",
    color: theme.text,
    marginBottom: "1rem",
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
  },
  selectContainer: {
    position: "relative",
    width: "100%",
  },
  select: {
    width: "100%",
    padding: "0.75rem",
    fontSize: "1rem",
    border: `2px solid ${theme.border}`,
    borderRadius: "0.5rem",
    backgroundColor: theme.surface,
    color: theme.text,
    cursor: "pointer",
    appearance: "none",
    background: `${
      theme.surface
    } url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='${encodeURIComponent(
      theme.textSecondary
    )}' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e") no-repeat right 0.75rem center/16px 16px`,
  },
  loadingContainer: {
    textAlign: "center",
    padding: "2rem",
    backgroundColor: theme.surface,
    borderRadius: "0.5rem",
    border: `2px solid ${theme.border}`,
    color: theme.textSecondary,
  },
  errorContainer: {
    textAlign: "center",
    padding: "2rem",
    backgroundColor: theme.error + "20",
    borderRadius: "0.5rem",
    border: `2px solid ${theme.error}`,
    color: theme.error,
  },
  headerCard: {
    backgroundColor: theme.surface,
    borderRadius: "0.5rem",
    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
    marginBottom: "1.5rem",
    padding: "1.5rem",
    border: `2px solid ${theme.primary}30`,
  },
  headerFlex: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    marginBottom: "1rem",
  },
  avatar: {
    width: "4rem",
    height: "4rem",
    backgroundColor: theme.primary + "20",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: `2px solid ${theme.primary}`,
  },
  characterName: {
    fontSize: "1.875rem",
    fontWeight: "bold",
    color: theme.text,
    marginBottom: "0.5rem",
  },
  infoGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "1rem",
    fontSize: "0.875rem",
  },
  infoItem: {
    color: theme.text,
  },
  label: {
    fontWeight: "600",
    color: theme.textSecondary,
  },
  combatStats: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "1rem",
    marginTop: "1rem",
  },
  statCard: {
    textAlign: "center",
    padding: "0.75rem",
    borderRadius: "0.5rem",
    border: "1px solid",
    backgroundColor: theme.surface,
  },
  statCardRed: {
    backgroundColor: theme.error + "20",
    borderColor: theme.error + "60",
  },
  statCardBlue: {
    backgroundColor: theme.primary + "20",
    borderColor: theme.primary + "60",
  },
  statCardBrown: {
    backgroundColor: theme.success + "20",
    borderColor: theme.success + "60",
  },
  statCardBrownHover: {
    backgroundColor: theme.success + "60",
    borderColor: theme.success + "100",
  },
  statValue: {
    fontSize: "1.25rem",
    fontWeight: "bold",
    marginBottom: "0.25rem",
  },
  statValueRed: {
    color: theme.error,
  },
  statValueBlue: {
    color: theme.primary,
  },
  statValueBrown: {
    color: theme.success,
  },
  statLabel: {
    fontSize: "0.875rem",
  },
  statLabelRed: {
    color: theme.error,
  },
  statLabelBlue: {
    color: theme.primary,
  },
  statLabelBrown: {
    color: theme.success,
  },
  abilityCard: {
    backgroundColor: theme.surface,
    borderRadius: "0.5rem",
    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
    padding: "1.5rem",
    border: `2px solid ${theme.primary}40`,
    marginBottom: "1.5rem",
  },
  abilityTitle: {
    fontSize: "1.25rem",
    fontWeight: "bold",
    color: theme.text,
    marginBottom: "1rem",
  },
  abilityGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(130px, 1fr))",
    gap: "1rem",
  },
  abilityItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0.75rem",
    backgroundColor: theme.background,
    borderRadius: "0.5rem",
    textAlign: "center",
    border: `1px solid ${theme.border}`,
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  abilityName: {
    fontWeight: "500",
    marginBottom: "0.5rem",
    color: theme.textSecondary,
  },
  abilityModifier: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    color: theme.text,
  },
  abilityScore: {
    fontSize: "0.875rem",
    color: theme.textSecondary,
    marginTop: "0.25rem",
  },
  skillsCard: {
    maxWidth: "600px",
    backgroundColor: theme.surface,
    borderRadius: "0.5rem",
    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
    padding: "1.5rem",
    border: `2px solid ${theme.border}`,
    marginBottom: "1.5rem",
    height: "1200px",
  },
  skillsTitle: {
    fontSize: "1.25rem",
    fontWeight: "bold",
    color: theme.text,
    marginBottom: "1rem",
    textAlign: "center",
    letterSpacing: "0.1em",
  },
  skillsTable: {
    width: "100%",
    borderCollapse: "collapse",
    backgroundColor: theme.surface,
  },
  skillsHeaderRow: {
    backgroundColor: theme.background,
    borderBottom: `2px solid ${theme.border}`,
  },
  skillsHeaderCell: {
    padding: "0.75rem 0.5rem",
    fontSize: "0.75rem",
    fontWeight: "bold",
    color: theme.textSecondary,
    textAlign: "center",
    borderRight: `1px solid ${theme.border}`,
    letterSpacing: "0.05em",
    cursor: "pointer",
    transition: "background-color 0.2s",
    userSelect: "none",
  },
  skillsHeaderCellLast: {
    padding: "0.75rem 0.5rem",
    fontSize: "0.75rem",
    fontWeight: "bold",
    color: theme.textSecondary,
    textAlign: "center",
    letterSpacing: "0.05em",
    cursor: "pointer",
    transition: "background-color 0.2s",
    userSelect: "none",
  },
  skillsHeaderCellHover: {
    backgroundColor: theme.primary + "20",
  },
  skillsHeaderCellActive: {
    backgroundColor: theme.primary + "30",
    color: theme.primary,
  },
  sortableHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.25rem",
  },
  skillRow: {
    borderBottom: `1px solid ${theme.border}`,
    transition: "background-color 0.2s",
  },
  skillRowHover: {
    backgroundColor: theme.background,
  },
  skillCell: {
    padding: "0.5rem",
    textAlign: "center",
    borderRight: `1px solid ${theme.border}`,
    verticalAlign: "middle",
  },
  skillCellLast: {
    padding: "0.5rem",
    textAlign: "center",
    verticalAlign: "middle",
  },
  proficiencyCircle: {
    width: "16px",
    height: "16px",
    borderRadius: "50%",
    border: `2px solid ${theme.textSecondary}`,
    backgroundColor: "transparent",
    cursor: "pointer",
    transition: "all 0.2s",
    display: "inline-block",
  },
  proficiencyCircleFilled: {
    backgroundColor: theme.text,
    borderColor: theme.text,
  },
  abilityMod: {
    fontSize: "0.75rem",
    fontWeight: "bold",
    color: theme.textSecondary,
    letterSpacing: "0.05em",
  },
  skillNameButton: {
    background: "none",
    border: "none",
    fontSize: "0.875rem",
    fontWeight: "500",
    color: theme.text,
    cursor: "pointer",
    padding: "0.25rem 0.5rem",
    borderRadius: "0.25rem",
    transition: "all 0.2s",
    textAlign: "left",
    width: "100%",
  },
  skillNameButtonProficient: {
    color: theme.primary,
    fontWeight: "600",
  },
  skillNameButtonHover: {
    backgroundColor: theme.background,
  },
  bonusValue: {
    fontSize: "0.875rem",
    fontWeight: "bold",
    color: theme.text,
    backgroundColor: theme.background,
    border: `1px solid ${theme.border}`,
    borderRadius: "0.25rem",
    padding: "0.25rem 0.5rem",
    minWidth: "35px",
    display: "inline-block",
  },
  instructionsCard: {
    marginTop: "1.5rem",
    backgroundColor: theme.surface,
    borderRadius: "0.5rem",
    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
    padding: "1rem",
    border: `2px solid ${theme.border}`,
  },
  instructionsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "1rem",
    fontSize: "0.875rem",
    color: theme.textSecondary,
  },
  instructionItem: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
  },
  warning: {
    marginTop: "0.5rem",
    fontSize: "0.75rem",
    color: theme.warning,
  },
});

export default styles;
